const navbarLinks: { [key: string]: any } = {
  home: "/home",
  dashboard: "/dashboard",
  liquidations: "/liquidations",
  referral: "/referral",
  docs: "https://renec-lend.gitbook.io/documents",
  staking: "/staking",
}

export default navbarLinks
